'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import posthog from 'posthog-js'
import { use, useEffect } from 'react'

import { posthogConfig } from './config'

export function IdentifyPosthogUser({
  userPromise,
}: {
  userPromise: Promise<{ qid: string; email: string } | null>
}) {
  const user = use(userPromise)

  useEffect(() => {
    if (!posthogConfig.enabled) return

    if (user?.qid) {
      posthog.identify(user.qid, { email: user.email, is_seller: true })
      if (!posthog.has_opted_in_capturing()) {
        posthog.opt_in_capturing()
      }
      posthog.startSessionRecording()
    } else {
      posthog.opt_out_capturing()
      posthog.stopSessionRecording()
      posthog.reset()
    }
  }, [user?.qid, user?.email])

  return null
}
